import React, { useState, createContext, useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

import Panel from "./panel/index.jsx";

import styles from "./styles.css";

export const StackingAccordionContext = createContext({});

export const STACKING_ACCORDION_TYPE = {
  TYPE_1: "type1",
  TYPE_2: "type2"
};

StackingAccordion.propTypes = {
  type: PropTypes.oneOf(Object.values(STACKING_ACCORDION_TYPE)),
  children: PropTypes.node.isRequired,
  defaultActiveKey: PropTypes.number
};
export function StackingAccordion({ children, type, defaultActiveKey = null }) {
  const [activePanelId, setActivePanelId] = useState(defaultActiveKey);

  const accordionInfo = useMemo(
    function handleInfo() {
      return { activeState: [activePanelId, setActivePanelId], type: type };
    },
    [type, activePanelId]
  );

  return (
    <div className={styles.accordionWrapper}>
      <StackingAccordionContext.Provider value={accordionInfo}>
        {children}
      </StackingAccordionContext.Provider>
    </div>
  );
}

StackingAccordion.Panel = Panel;
